import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface UsersData {
  name: string;
  id: number;
}


@Component({
  selector: 'app-absent-appointment',
  templateUrl: './absent-appointment.component.html',
  styleUrls: ['./absent-appointment.component.css']
})
export class AbsentAppointmentComponent {

  action: string;
  local_data: any;

  constructor(
    public dialogRef: MatDialogRef<AbsentAppointmentComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  doAction() {
    this.dialogRef.close({ event: 'Accept', data: this.local_data });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
